<template>
    <info-screen
            class="startRegistration"
            :title="$ml.get('infoSelectLoginTitle')"
            :text="$ml.get('infoSelectLoginText')"
            :action="nextScreen"
            :buttonText="$ml.get('infoSelectLoginButton')"
            :titleH1="false"
            :headerImg="4"
    ></info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    export default {
        name: "infoSelectLoginPage",
        components: {InfoScreen},
        created() {
            let isMobile = window.innerWidth < 600;
            if (!isMobile) {
                this.$router.replace({ name: 'AccessRecoverySelectLogin'});
            }
        },
        methods: {
            nextScreen: function () {
                this.$router.push({ name: 'AccessRecoverySelectLogin'});
            },
        }
    }
</script>

<style scoped>

</style>